import { render } from "./FormForgotPassword.vue?vue&type=template&id=ae961cd0&scoped=true"
import script from "./FormForgotPassword.vue?vue&type=script&lang=js"
export * from "./FormForgotPassword.vue?vue&type=script&lang=js"

import "./FormForgotPassword.vue?vue&type=style&index=0&id=ae961cd0&scoped=true&lang=css"
import "./FormForgotPassword.vue?vue&type=style&index=1&id=ae961cd0&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae961cd0"]])

export default __exports__